import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import _ from 'lodash';
import async from 'async';
import { Card, CardText } from 'material-ui';
import classnames from 'classnames';

import ChannelService from 'services/ChannelService'
import IncmsService from 'services/IncmsService';
import { email, required } from 'constants/InputErrors';
import { FormGroup, Text, Textarea } from 'components/FormElements';
import IntlMessages from 'util/IntlMessages';
import { toggleAlertError, toggleLoading } from 'stores/actions';

class ChannelPhoneModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      channelAccount: null,
      searchExecuted: false,
      incmsAccounts: [],
      selectedAccount: {},
      accountToLink: null,
    };

    this.searchAccounts = this.searchAccounts.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.open && !this.props.open ) {
      this.setState( {
        incmsAccounts: [], searchExecuted: false, channelAccount: null, accountToLink: null,
        selectedAccount: _.get( nextProps, 'data.phoneCalling' ) ? { phone: nextProps.data.phoneCalling } : {},
        type: nextProps.data.type
      } );
      this.searchFormData = null;
        
      if( nextProps.data && nextProps.data.phoneCalling ) {
        
        this.getData( nextProps.data.phoneCalling )
      }
    }
  }

  getData( phone ) {
    this.props.toggleLoading( true );

    async.waterfall( [
      ( cb ) => {
        ChannelService.searchChannelByPhone( { phoneNumber: phone } ).then( ( response ) => {
          if( response.errors ) return cb( null, false );
          return cb( null, response.data );
        } );
      },
      ( channelAccount, cb ) => {
        if( channelAccount ) return cb( null, { channelAccount } );

        IncmsService.searchProfile( { 'filters[phone]': phone } ).then( ( response ) => {
          if( response.errors ) return cb( response.errors );
          return cb( null, { incmsAccounts: response.data } );
        } );
      },
    ], ( error, results ) => {
      if( !error ) {
        if( results.channelAccount ) {
          this.setState( {
            channelAccount: results.channelAccount,
            searchExecuted: true,
            selectedAccount: {
              name: results.channelAccount.name,
              email: results.channelAccount.email,
              phone: results.channelAccount.phone,
            }
          } )
        } else {
          if( results.incmsAccounts ) this.setState( { incmsAccounts: results.incmsAccounts, searchExecuted: true, } );
          else this.setState( { searchExecuted: true, } );
        }
      } else {
        // console.log(`object`, error.toString().indexOf('not found'));
        if (error.toString().indexOf('not found') !== 1) {
          this.setState( { searchExecuted: true, } );
        } 
      }
      this.props.toggleLoading( false );
    } );
  }

  searchAccounts( data ) {
    this.searchFormData = data;
    this.props.toggleLoading( true );

    let filterParams = {};
    _.map( data, ( value, filter ) => {
      if( value ) filterParams[`filters[${filter}]`] = value;
    } );
    IncmsService.searchProfile( filterParams ).then( ( response ) => {
      if( response.data ) this.setState( { incmsAccounts: response.data } );
      this.props.toggleLoading( false );
    } )
  }

  submitForm( data ) {
    const { onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;
    const { accountToLink } = this.state;

    toggleLoading( true );

    ChannelService.searchChannelByPhone( { phoneNumber: data.phone } ).then( ( response ) => {
      if( response.data ) {
        ChannelService.updateChannelStatus( response.data.id, {
          status: 'open',
          name: data.name,
          email: data.email,
          callPhone: true,
          lastComment: data.content,
        } ).then( ( response ) => {
          toggleLoading( false );
          if( response.errors ) return toggleAlertError( response.errors );
          onReloadData( response.data.id );
          onClose()
        } )
      } else {
        async.waterfall( [
          ( cb ) => {
            switch (this.state.type ) {
              case 'new':
                const formattedData = {
                  name: data.name,
                  email: data.email,
                  phone: data.phone,
                  type: 'message',
                  content: data.content
                };
                ChannelService.saveChannelPhone( formattedData ).then( ( response ) => {
                  if( response.errors ) return cb( response.errors );
                  return cb( null, { channel: response.data } )
                  } )
                break;
              case 'walkin':
                const formattedWalkData = {
                  name: data.name,
                  email: data.email,
                  phone: data.phone,
                  content: data.content
                };
                ChannelService.saveChannelWalkin( formattedWalkData ).then( ( response ) => {
                  if( response.errors ) return cb( response.errors );
                  return cb( null, { channel: response.data } )
                  } )
                break;
              default:
                break;
            }
          },
          ( resultData, cb ) => {
            if( !accountToLink ) return cb( null, resultData );
            let dataToSend = {
              "idAccount": accountToLink.idAccount,
              "account": accountToLink.account,
              "idCustomer": accountToLink.idCustomer,
              "incmsDataobj": JSON.stringify( accountToLink ),
              "channel": resultData.channel.id
            };
            ChannelService.saveChannelAccount( dataToSend ).then( response => {
              if( response.errors ) return cb( response.errors );
              return cb( null, { ...resultData, account: response.data } )
            } );
          },
          ( resultData, cb ) => {
            if( !accountToLink || accountToLink.idSocialAccount ) return cb( null, resultData );

            IncmsService.linkCustomer( resultData.channel.id, { account: resultData.account.id } )
              .then( ( response ) => {
                if( response.errors ) return cb( response.errors );
                return cb( null, resultData )
              } );
          }
        ], ( errors, results ) => {
          toggleLoading( false );
          if( errors ) return toggleAlertError( errors );
          onReloadData( results.channel.id );
          onClose()
        } )
      }
    } );
  }

  onSelectCard( account ) {
    this.setState( {
      channelAccount: null,
      accountToLink: account,
      selectedAccount: {
        name: account.fullName,
        email: account.email,
        phone: _.get( this.props, 'data.phoneCalling' ) ? this.formGetValues( 'phone' ) : account.phone.trim(),
      }
    } )
  }

  render() {
    const { user, data = {}, open, onClose, externalCustomer } = this.props;
    const { channelAccount, incmsAccounts, selectedAccount, searchExecuted, accountToLink } = this.state;
    const phone = data && data.phoneCalling ? data.phoneCalling : null;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName={classnames( 'max-width-unset', {
               'col-md-5': ( phone && !searchExecuted ) || ( phone && searchExecuted && channelAccount ),
               'col-md-10': !phone || ( searchExecuted && !channelAccount ),
             } )}
             open={open}
             onClose={onClose}>
        {!phone ?
          <h5 className="mt-0"><IntlMessages id="createCase"/></h5> :
          <h5 className="mt-0"><IntlMessages id="callFrom"/>: {data.phoneCalling}</h5>
        }

        <div className="row">
          {( !phone || ( searchExecuted && !channelAccount ) ) &&
          <div className="col-md-7 border-right">
            <Form
              defaultValues={this.searchFormData || { phone }}
              onSubmit={this.searchAccounts}>
              {( { getValue, submitForm } ) =>
                <form onSubmit={submitForm} className="mt-4">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <Text field="account"
                            placeholder="incmsAccountReference"
                            className="form-control"/>
                    </div>
                    <div className="col-md-6 pl-0">
                      <Text field="meterNumber"
                            placeholder="meterSerialNumber"
                            className="form-control"/>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <Text field="documentNumber"
                            placeholder="nationalNumber"
                            className="form-control"/>
                    </div>
                    <div className="col-md-6 pl-0">
                      <Text field="phone" placeholder="customerPhone"
                            className="form-control"/>
                    </div>
                  </div>

                  <hr/>
                  <div className="text-right">
                    <button className="btn btn-info"
                            disabled={!getValue( 'documentNumber' ) && !getValue( 'phone' ) && !getValue( 'account' ) && !getValue( 'meterNumber' )}>
                      <Translate id="search"/>
                    </button>
                  </div>
                </form>
              }
            </Form>

            <div className="row content mt-3">
              {_.map( incmsAccounts, ( item, index ) =>
                <div key={index} className="col-md-6 mt-1 mb-3">
                  <Card containerStyle={{ cursor: 'pointer' }} onClick={() => {
                    this.onSelectCard( item )
                  }}>
                    <CardText>
                      <div className="col-md-12 p-0">
                        <div className="row">
                          <div className="col-md-3"><Translate id="name"/></div>
                          <div className="col-md-9 text-small text-muted">{item.fullName}</div>
                        </div>

                        <div className="row">
                          <div className="col-md-3"><Translate id="email"/></div>
                          <div className="col-md-9 text-small text-muted">{item.email || '---'}</div>
                        </div>
                        <div className="row">
                          <div className="col-md-3"><Translate id="phone"/></div>
                          <div className="col-md-9 text-small text-muted">{item.phone || '---'}</div>
                        </div>
                        <div className="row">
                          <div className="col-md-3"><Translate id="account"/></div>
                          <div className="col-md-9 text-small text-muted">{item.account || '---'}</div>
                        </div>
                        <div className="row">
                          <div className="col-md-3"><Translate id="location"/></div>
                          <div
                            className="col-md-9 text-small text-muted">{item.location || '---'}</div>
                        </div>
                        <div className="row">
                          <div className="col-md-3"><Translate id="doc"/></div>
                          <div className="col-md-9 text-small text-muted">
                            {item.docNumber ? `#${item.docNumber}` : '---'}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3"><Translate id="supply"/></div>
                          <div className="col-md-9 text-small text-muted">
                            {item.supplyNumber ? `#${item.supplyNumber}` : '---'}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3"><Translate id="meter"/></div>
                          <div className="col-md-9 text-small text-muted">
                            {item.meterNumber ? `#${item.meterNumber}` : '---'}
                          </div>
                        </div>
                      </div>
                    </CardText>
                  </Card>
                </div>
              )}

              {!incmsAccounts.length &&
              <div className="col-md-12 text-center">
                <h4 className="text-muted mt-0"><Translate id="noDataFound"/></h4>
              </div>
              }
            </div>
          </div>
          }

          <div className={classnames( 'max-width-unset', {
            'col-md-12': ( phone && !searchExecuted ) || ( phone && searchExecuted && channelAccount ),
            'col-md-5': !phone || ( searchExecuted && !channelAccount ),
          } )}
          >
            {accountToLink ?
              <div className="row mb-3">
                <div className="col-12">
                  <div className="bg-color-info d-flex justify-content-between align-items-center p-3">
                    <span>
                      <IntlMessages id="accountToLink"/>: {accountToLink.supplyNumber} - {accountToLink.fullName}
                    </span>
                    <i className="icon-close pointer" onClick={() => this.setState( { accountToLink: null } )}/>
                  </div>
                </div>
              </div> : null
            }
            <Form defaultValues={selectedAccount}
                  onSubmit={this.submitForm}
                  validate={( values ) => {
                    return {
                      content: required( values.content ),
                      name: required( values.name ),
                      phone: required( values.phone ),
                      //email: required( values.email ),
                    }
                  }}
            >
              {( { getValue, submitForm } ) => {
                this.formGetValues = getValue;
                return (
                  <form onSubmit={submitForm}>
                    <div className="row">
                      <FormGroup containerClass="col-md-6">
                        <label><Translate id="contactName"/></label>
                        <Text field="name" className="form-control"/>
                      </FormGroup>
                      <FormGroup containerClass="col-md-6">
                        <label><Translate id="contactEmail"/></label>
                        <Text field="email" className="form-control"/>
                      </FormGroup>
                    </div>

                    <div className="row">
                      <FormGroup containerClass="col-md-6">
                        <label><Translate id="contactPhone"/></label>
                        <Text field="phone" className="form-control"/>
                      </FormGroup>
                    </div>

                    <FormGroup>
                      <label><Translate id="comment"/></label>
                      <Textarea field="content" className="form-control" rows={5}/>
                    </FormGroup>


                    {phone && channelAccount && channelAccount.status === 'open' && _.get( channelAccount, 'agent.id' ) === user.id ?
                      <div className="row mb-2">
                        <div className="col-12 text-danger">
                          <IntlMessages id="channelOpenedError"/>
                        </div>
                      </div> : null
                    }
                    {phone && channelAccount && channelAccount.status === 'open' && _.get( channelAccount, 'agent.id' ) !== user.id ?
                      <div className="row mb-2">
                        <div className="col-12 text-danger">
                          <IntlMessages id="channelAssignedError"/>
                        </div>
                      </div> : null
                    }

                    <div className="text-right">
                      <button className="btn btn-info"><Translate id="submit"/></button>
                    </div>
                  </form>
                )
              }}
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  user: state.user,
  externalCustomer: state.settings.externalCustomer,

} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( ChannelPhoneModal );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/PhoneCallModal/index.js